import { FINISH_GIVEAWAY } from 'root/src/shared/descriptions/endpoints/endpointIds'

import finishGiveawayPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/finishGiveawayPayloadSchema'

export default {
	[FINISH_GIVEAWAY]: {
		payloadSchema: finishGiveawayPayloadSchema,
	},
}
